import type { Coupon, StoreSettings } from '@/types'

type ShippingRules = Pick<StoreSettings, 'shipping_cost' | 'free_shipping_threshold'>

export const shippingFor = (rules: ShippingRules, amount: number): number => {
    if (amount <= 0) return 0
    if (rules.free_shipping_threshold > 0 && amount >= rules.free_shipping_threshold) return 0

    return rules.shipping_cost
}

export const remainingForFreeShipping = (rules: ShippingRules, amount: number): number => {
    if (rules.free_shipping_threshold <= 0) return 0

    return Math.max(0, rules.free_shipping_threshold - amount)
}

export const couponDiscount = (coupon: Pick<Coupon, 'discount_type' | 'discount_value'>, subtotal: number): number => {
    if (subtotal <= 0) return 0

    const raw = coupon.discount_type === 'percent'
        ? Math.floor((subtotal * Math.min(100, Math.max(0, coupon.discount_value))) / 100)
        : coupon.discount_value

    return Math.max(0, Math.min(subtotal, raw))
}
